import React from 'react';

const Throbber = () => {
  return (
    <div>
      <div className="iris_throbber">
        <div className="iris_throbber-dot iris_throbber-dot--blue" />
        <div className="iris_throbber-dot iris_throbber-dot--green" />
        <div className="iris_throbber-dot iris_throbber-dot--red" />
      </div>
    </div>
  );
};

export default Throbber;
